import styled, {
  breakpoints,
  css,
  Device,
  IFalconTheme,
  Image,
  Layout,
  Scale,
  StyledComponent,
} from '@se-admin/falcon';

export const BookingDetailsPageWrapper: StyledComponent<'div', IFalconTheme> = styled('div')(
  ({ theme }: { theme: IFalconTheme }) => css`
    background-color: ${theme.color.white};
    @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
      display: grid;
      grid-template-columns: 50% 50%;
    }
  `
);

export const BookingDetailsWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  padding-right: ${Scale.m};
  padding-left: ${Scale.m};
  @media only screen and (min-width: ${breakpoints[Device.tablet]}) {
    padding: ${Scale.xl};
  }
`;

export const BookingDetailsOccupancyWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  display: grid;
  grid-template-columns: minmax(min-content, max-content) auto;
  align-items: center;
  grid-gap: ${Scale.xs};
  padding-top: ${Scale.m};
`;

export const BookingDetailsDatesWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  display: flex;
  gap: ${Scale.m};
  justify-content: space-between;
  align-items: center;
`;

export const BookingDetailsHotelWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  padding-top: ${Scale.m};
  padding-bottom: ${Scale.xl};
`;

export const BookingDetailsHotelDetailslWrapper: StyledComponent<'div', IFalconTheme> = styled(
  'div'
)`
  display: grid;
  grid-template-columns: minmax(min-content, max-content) auto;
  column-gap: ${Scale.xxs};
`;

export const BookingDetailsImageWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  padding-bottom: ${Scale.m};
`;

export const BookingDatesItemWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  margin-right: ${Scale.m};
`;

export const HorizontalSeperator: StyledComponent<'hr', IFalconTheme, {}> = styled('hr')(
  ({ theme }: { theme: IFalconTheme }) => {
    return css`
      margin: ${Scale.m} 0;
      border-top: 1px solid ${theme.color.grey30};
    `;
  }
);

export const BookingDetailsTransactionWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  display: grid;
  grid-template-columns: minmax(min-content, max-content) auto;
  column-gap: ${Scale.xs};
`;

export const CustomNormalImage: StyledComponent<typeof Image, {}, {}> = styled(Image)`
  top: 0;
  left: 0;
`;

export const BookingDetailsButtonWrapper: StyledComponent<
  typeof Layout.Container,
  IFalconTheme,
  {}
> = styled(Layout.Container)`
  justify-content: flex-end;
  padding-top: ${Scale.m};
  padding-bottom: ${Scale.m};
`;

export const BookingNotCancellableWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  margin: ${Scale.xxs};
`;
